<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <a-layout-sider
      :trigger="null"
      collapsible
      style="background: #fff"
      v-model="collapsed"
    >
      <div class="logo" @click="changeTheme('#722ED1')">
        <template v-if="!collapsed">
          <span style="font-size: 24px">JOFPH-后台管理</span>
        </template>
        <template v-else>
          <small style="font-size: 20px; color: #fff">JOFPH</small>
        </template>
        <!-- <img src="./images/icon_tran.png" alt=""> -->
      </div>
      <a-menu
        theme="light"
        mode="inline"
        :openKeys="openKeys"
        @openChange="onOpenChange"
        @click="onMenuClick"
        :selectedKeys="[active]"
        :forceSubMenuRender="true"
      >
        <template v-for="item in menus">
          <a-sub-menu
            v-if="item.children && item.children.length"
            :key="item.path"
          >
            <span slot="title">
              <a-icon :type="item.icon" /><span>{{ item.name }}</span></span
            >
            <a-menu-item v-for="child in item.children" :key="child.path">
              <router-link :to="child.path">{{ child.name }}</router-link>
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item v-else :key="item.path">
            <router-link :to="item.path">
              <a-icon :type="item.icon" />
              <span>{{ item.name }}</span>
            </router-link>
          </a-menu-item>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #014f9a; padding: 0">
        <span
          v-if="collapsed"
          style="font-size: 24px; margin-left: 16px; color: #fff"
          >后台管理</span
        >
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="() => (collapsed = !collapsed)"
        />
        <!-- <div class="main-nav-list">
          <div v-for="(item, index) in mainNavList"
               :class="item.path === choMenus? 'active':''"
               @click="changeMainNavList(item.path)"
               :key="'mainNavList' + index"><span class="inline-svg"> <img :src="item.img">{{item.name}} </span></div>
        </div> -->
        <div class="user-avatar">
          <a-avatar
            v-if="user && user.nickname"
            :size="36"
            style="color: #f56a00; backgroundcolor: #fde3cf"
            >{{ user.nickname.substr(0, 1) }}</a-avatar
          >
          <a-avatar v-else :size="36" icon="user" />
          <a-dropdown>
            <a class="ant-dropdown-link" style="color: #fff" href="#">
              {{ (user && user.nickname) || "未登录" }}
            </a>
            <a-menu slot="overlay" v-if="user && user.nickname">
              <!-- <a-menu-item>
                <a v-on:click="changePwd()">修改密码</a>
              </a-menu-item> -->
              <a-menu-item>
                <a v-on:click="logout()">退出登录</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-layout-header>
      <a-layout-content>
        <router-view></router-view>
      </a-layout-content>
      <ChangePwd
        :isModalVisible="isModalVisible"
        ref="collectionForm"
        @cancel="handleCancel"
        @create="handleCreate"
      />
    </a-layout>
  </a-layout>
</template>

<style scoped lang="scss">
@import "./main.scss";
</style>

<script>
import main from "./main.js";
export default main;
</script>
